import { MainDomain, apiGet } from "api";

const clientContact = {
    getAll: async (clientId: number) => {
        const data = await apiGet(`https://crm-api.${MainDomain}.co.za/api/contact/getall?clientId=${clientId}`);
        // const data = await apiGet(`https://crm-api.amasocial.co.za/api/contact/getall?clientId=${clientId}`);
        return data;
    }
}

export default clientContact;